/**
 * 분석 코드 선택지 — 종류 레지스트리 구동(2026-09-01 결정 1안). 저작 코드 선언(participantCodes)에 있는 코드만 선택지에 오른다.
 * 선언을 레지스트리가 아니라 여기서 직접 읽는 이유: 이 모듈은 프로젝트 피커(진입 청크)가 쓰고, 레지스트리(participantKinds)는
 * 해석 도메인(파서·생성기)을 정적으로 끌어 진입 청크 검출기(`src/__tests__/entryChunk.test.ts`)가 거절한다. 레지스트리의
 * `authoring.analysisCodes` 가 같은 선언을 참조로 붙이므로 정본은 하나다:
 * 새 코드(예: GAMMA+)는 스펙을 등록하는 순간 자동으로 등장하고, 등록 전엔 생성 시점 함정이 되지 않는다.
 * 색·칩 스타일은 domain/analysisCodeRegistry 가 정본이다.
 */
import type { AnalysisCode } from '@/types/project';
import { ANALYSIS_CODE_STYLES } from '@/domain/analysisCodeRegistry';
import { PARTICIPANT_AUTHORING_CODES } from './participantCodes';

export function analysisCodeChoices(): readonly AnalysisCode[] {
  const seen = new Set<AnalysisCode>();
  for (const codes of Object.values(PARTICIPANT_AUTHORING_CODES)) {
    for (const code of codes as readonly string[]) {
      // 자기 속성만 — analysisCodes 는 임의 문자열이라 'constructor' 같은 상속 키가 스타일 있는 코드로 새면 안 된다
      if (Object.prototype.hasOwnProperty.call(ANALYSIS_CODE_STYLES, code)) seen.add(code as AnalysisCode);
    }
  }
  return [...seen];
}
